(function () {

  var isMobile   = function() { return window.innerWidth <= 900; };
  var isHome     = document.body.classList.contains('template-index');
  var isPageTpl  = document.body.classList.contains('template-page');
  var isShopPage = document.body.classList.contains('template-collection') ||
                   document.body.classList.contains('template-product') ||
                   document.body.classList.contains('template-cart');

  // ── SCROLL LOCK — body+html locked; flex chain handles scroll inside #page-content ──
  if (isShopPage) {
    document.documentElement.style.overflowY = 'hidden';
    document.body.style.overflowY = 'hidden';
  }

  // ── PAGE TRANSITIONS ─────────────────────────────────────────────────────
  var overlay = document.getElementById('page-transition');
  if (overlay) {
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'all';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.style.transition = 'opacity .35s ease';
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      });
    });
  }

  function navigateTo(href) {
    if (!overlay) { window.location.href = href; return; }
    overlay.style.transition = 'opacity .22s ease';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'all';
    setTimeout(function() { window.location.href = href; }, 240);
  }

  // Logo → home, with the same fade transition as the rest of the nav
  [].forEach.call(document.querySelectorAll('.sigil-link'), function(a) {
    a.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.location.pathname === '/') return;   // already home
      navigateTo('/');
    });
  });

  // Menu links saved as absolute https://…myshopify.com URLs hop domains, which drops
  // the storefront-password cookie and bounces visitors to the password page.
  // Rewrite same-store absolute links to stay on the current domain.
  (function() {
    var MYSHOP = /^https?:\/\/[^\/]*\.myshopify\.com(\/|$)/i;
    function toPath(h) { return h.replace(/^https?:\/\/[^\/]+/i, '') || '/'; }
    [].forEach.call(document.querySelectorAll('a[href]'), function(a) {
      var h = a.getAttribute('href');
      if (h && MYSHOP.test(h)) a.setAttribute('href', toPath(h));
    });
    [].forEach.call(document.querySelectorAll('[data-href]'), function(el) {
      var h = el.getAttribute('data-href');
      if (h && MYSHOP.test(h)) el.setAttribute('data-href', toPath(h));
    });
  })();

  // ── RESTRICTED PRODUCT MODAL ─────────────────────────────────────────────
  (function() {
    var backdrop  = document.getElementById('restrict-backdrop');
    var inputEl   = document.getElementById('restrict-input');
    var errEl     = document.getElementById('restrict-error');
    var submitBtn = document.getElementById('restrict-submit');
    var cancelBtn = document.getElementById('restrict-cancel');
    if (!backdrop) return;
    var pendingHref = null;
    window.showRestrictModal = function(href) {
      pendingHref = href;
      if (inputEl) inputEl.value = '';
      if (errEl)   errEl.style.display = 'none';
      backdrop.classList.add('open');
      if (inputEl) setTimeout(function() { inputEl.focus(); }, 50);
    };
    function tryUnlock() {
      var pass = (window.__RESTRICT_PASS__ || '').trim();
      if (!pass) { if (errEl) { errEl.textContent='RESTRICTED'; errEl.style.display='block'; } if (inputEl) inputEl.value=''; return; }
      if (inputEl && inputEl.value.trim() === pass) {
        backdrop.classList.remove('open');
        if (pendingHref) navigateTo(pendingHref);
      } else {
        if (errEl) errEl.style.display = 'block';
        if (inputEl) { inputEl.value = ''; inputEl.focus(); }
      }
    }
    if (submitBtn) submitBtn.addEventListener('click', tryUnlock);
    if (inputEl)   inputEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') tryUnlock(); });
    if (cancelBtn) cancelBtn.addEventListener('click', function() { backdrop.classList.remove('open'); pendingHref = null; });
    backdrop.addEventListener('click', function(e) { if (e.target === backdrop) { backdrop.classList.remove('open'); pendingHref = null; } });
  })();

  // ── VIDEO INTRO ───────────────────────────────────────────────────────────
  (function() {
    var vi = document.getElementById('video-intro');
    if (!vi) return;
    if (localStorage.getItem('somar-intro-seen') === '1') { vi.style.display = 'none'; return; }
    vi.classList.add('open');
    var player = document.getElementById('vi-player');
    if (player) player.play().catch(function(){});
    function closeVI() {
      vi.style.transition = 'opacity .4s';
      vi.style.opacity = '0';
      setTimeout(function() { vi.classList.remove('open'); vi.style.opacity = ''; vi.style.display = 'none'; }, 400);
      localStorage.setItem('somar-intro-seen', '1');
      if (player) player.pause();
    }
    var closeBtn = document.getElementById('vi-close');
    var enterBtn = document.getElementById('vi-enter');
    var skipBtn  = document.getElementById('vi-skip');
    if (closeBtn) closeBtn.addEventListener('click', closeVI);
    if (enterBtn) enterBtn.addEventListener('click', closeVI);
    if (skipBtn)  skipBtn.addEventListener('click', closeVI);
  })();

  // ── LIMITED PRE-ORDER COUNTDOWN ──────────────────────────────────────────
  // Drives both the product-page panel and the grid badges. When the window
  // elapses the product is closed off in place — no reload needed — and the
  // server-side check in Liquid keeps it closed on every subsequent load.
  (function() {
    var els = [].slice.call(document.querySelectorAll('[data-po-countdown]'));
    if (!els.length) return;

    function closeOut() {
      // Product page: disable every add-to-cart path and relabel
      [].forEach.call(document.querySelectorAll('.atc-btn'), function(b) {
        b.disabled = true;
        b.classList.add('sold-out');
        b.textContent = 'PRE-ORDER CLOSED';
      });
      [].forEach.call(document.querySelectorAll('.po-panel'), function(p) { p.classList.add('po-is-closed'); });
      [].forEach.call(document.querySelectorAll('.po-badge'), function(b) {
        b.classList.add('po-closed');
        b.textContent = b.classList.contains('po-badge-page') ? 'PRE-ORDER CLOSED' : 'PRE-ORDER CLOSED';
      });
      // Grid: stop quick-buy on any card whose window just closed
      [].forEach.call(document.querySelectorAll('.product-card .qb-card'), function(q) {
        var card = q.closest('.product-card');
        if (card && card.querySelector('.po-badge.po-closed')) q.style.display = 'none';
      });
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var anyLive = false;
      els.forEach(function(el) {
        var t = new Date(el.dataset.poCountdown).getTime();
        if (isNaN(t)) { el.textContent = 'SOON'; return; }
        var diff = t - Date.now();
        if (diff <= 0) {
          if (el.dataset.poScope === 'page') { el.textContent = '—'; closeOut(); }
          else { el.classList.add('po-closed'); el.textContent = 'PRE-ORDER CLOSED'; }
          return;
        }
        anyLive = true;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (el.dataset.poScope === 'page') {
          el.textContent = (d > 0 ? d + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        } else {
          el.textContent = d > 0 ? 'PRE-ORDER · ' + d + 'D LEFT'
                                 : 'PRE-ORDER · ' + pad(h) + ':' + pad(m) + ':' + pad(s);
        }
      });
      if (!anyLive) clearInterval(iv);
    }
    tick();
    var iv = setInterval(tick, 1000);
  })();

  // ── DROP COUNTDOWN (coming-soon cards in drop mode) ──────────────────────
  [].slice.call(document.querySelectorAll('.product-mini-cd')).forEach(function(el) {
    var target = new Date(el.dataset.drop).getTime();
    if (isNaN(target)) { el.textContent = 'SOON'; return; }
    function upd() {
      var diff = target - Date.now();
      if (diff <= 0) { el.textContent = 'LIVE'; clearInterval(iv); return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = (d > 0 ? d + 'D ' : '') +
        String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
    }
    upd();
    var iv = setInterval(upd, 1000);
  });

  // ── CURSOR + HITMARKER — attached early so they work even if canvas setup fails ──
  (function(){
    if (isMobile()) return;
    var c = document.getElementById('cur');
    if (c) {
      document.addEventListener('mousemove', function(e) {
        c.style.left = e.clientX + 'px';
        c.style.top  = e.clientY + 'px';
      });
      document.addEventListener('mouseleave', function() { c.style.opacity = '0'; });
      document.addEventListener('mouseenter', function() { c.style.opacity = '1'; });
    }
    document.addEventListener('click', function(e) {
      /* Only fire on interactive elements (links, buttons, inputs) */
      var el = e.target, hit = false;
      for (var t = el; t && t !== document.body; t = t.parentElement) {
        var tn = (t.tagName || '').toUpperCase();
        if (tn === 'A' || tn === 'BUTTON' || tn === 'INPUT' || tn === 'SELECT' || tn === 'LABEL') { hit = true; break; }
        if (t.getAttribute('role') === 'button') { hit = true; break; }
      }
      if (!hit) return;
      var hm = document.createElement('div');
      hm.className = 'hm';
      hm.style.left = e.clientX + 'px';
      hm.style.top  = e.clientY + 'px';
      for (var i = 0; i < 4; i++) {
        var l = document.createElement('div'); l.className = 'hm-l'; hm.appendChild(l);
      }
      document.body.appendChild(hm);
      setTimeout(function(){ if (hm.parentNode) hm.parentNode.removeChild(hm); }, 420);
    });
  })();

  /* Reload on bfcache restore so collection event listeners re-attach cleanly */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) window.location.reload();
  });

  // ── CANVAS — light grey spherical grid ────────────────────────────────────
  var bgc = document.getElementById('bgc');
  if (!bgc) return;
  var ctx = bgc.getContext('2d');
  var CW = 0, CH = 0;

  function resizeBgc() { CW = bgc.width = window.innerWidth; CH = bgc.height = window.innerHeight; }
  window.addEventListener('resize', resizeBgc);
  resizeBgc();

  function proj(latDeg, lonDeg, vElDeg, vAzDeg) {
    var D = Math.PI/180;
    var latR=latDeg*D,lonR=lonDeg*D,eR=vElDeg*D,aR=vAzDeg*D;
    var x0=Math.cos(latR)*Math.sin(lonR),y0=Math.sin(latR),z0=Math.cos(latR)*Math.cos(lonR);
    var x1=x0*Math.cos(-aR)+z0*Math.sin(-aR), z1=-x0*Math.sin(-aR)+z0*Math.cos(-aR);
    var y2=y0*Math.cos(-eR)-z1*Math.sin(-eR), z2=y0*Math.sin(-eR)+z1*Math.cos(-eR);
    if(z2<=0.01)return null;
    var sc=Math.min(CW,CH)*0.62;
    return[CW/2+(x1/z2)*sc, CH/2-(y2/z2)*sc];
  }

  function drawGrid(vEl, vAz) {
    var dark = document.body.classList.contains('dark-mode');
    ctx.fillStyle = dark ? '#0f0f0f' : '#d4d4d4';
    ctx.fillRect(0, 0, CW, CH);

    // Subtle radial depth
    var g = ctx.createRadialGradient(CW/2,CH/2,0,CW/2,CH/2,Math.max(CW,CH)*0.72);
    g.addColorStop(0,   dark ? 'rgba(30,30,30,0.2)'   : 'rgba(230,230,230,0.2)');
    g.addColorStop(0.5, 'rgba(0,0,0,0)');
    g.addColorStop(1,   dark ? 'rgba(0,0,0,0.28)'      : 'rgba(150,150,150,0.18)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, CW, CH);

    ctx.strokeStyle = dark ? '#2e2e2e' : '#888888';
    var pen = false;

    // Minor grid (every 5°)
    ctx.lineWidth = 0.3; ctx.globalAlpha = 0.18;
    for (var lat=-80;lat<=80;lat+=5) {
      if (lat%15===0) continue;
      ctx.beginPath(); pen=false;
      for (var lon=-180;lon<=180;lon+=3) {
        var p=proj(lat,lon,vEl,vAz); if(!p){pen=false;continue;}
        pen?ctx.lineTo(p[0],p[1]):(ctx.moveTo(p[0],p[1]),pen=true);
      } ctx.stroke();
    }
    for (var lon2=-180;lon2<=180;lon2+=5) {
      if (lon2%15===0) continue;
      ctx.beginPath(); pen=false;
      for (var lat2=-89;lat2<=89;lat2+=3) {
        var p2=proj(lat2,lon2,vEl,vAz); if(!p2){pen=false;continue;}
        pen?ctx.lineTo(p2[0],p2[1]):(ctx.moveTo(p2[0],p2[1]),pen=true);
      } ctx.stroke();
    }

    // Major lat lines
    for (var mlat=-75;mlat<=75;mlat+=15) {
      ctx.lineWidth = mlat===0?1:0.55;
      ctx.globalAlpha = mlat===0?0.5:0.35;
      ctx.beginPath(); pen=false;
      for (var mlon=-180;mlon<=180;mlon+=2) {
        var mp=proj(mlat,mlon,vEl,vAz); if(!mp){pen=false;continue;}
        pen?ctx.lineTo(mp[0],mp[1]):(ctx.moveTo(mp[0],mp[1]),pen=true);
      } ctx.stroke();
    }

    // Major lon lines
    ctx.lineWidth=0.55; ctx.globalAlpha=0.35;
    for (var ll=-165;ll<=180;ll+=15) {
      ctx.beginPath(); pen=false;
      for (var ll2=-89;ll2<=89;ll2+=2) {
        var llp=proj(ll2,ll,vEl,vAz); if(!llp){pen=false;continue;}
        pen?ctx.lineTo(llp[0],llp[1]):(ctx.moveTo(llp[0],llp[1]),pen=true);
      } ctx.stroke();
    }

    // Dots at major intersections
    ctx.fillStyle = dark ? '#3a3a3a' : '#666666';
    for (var dl=-75;dl<=75;dl+=15) {
      for (var dln=-165;dln<=180;dln+=15) {
        var dp=proj(dl,dln,vEl,vAz); if(!dp)continue;
        ctx.globalAlpha=0.5-Math.abs(dl)/75*0.2;
        ctx.beginPath(); ctx.arc(dp[0],dp[1],1.6,0,Math.PI*2); ctx.fill();
      }
    }
    ctx.globalAlpha=1;
  }

  var VP = { tx:0, ty:0, vAz:0, vEl:0 };
  var LERP = 0.065;

  // ── COMPASS — erratic drift ───────────────────────────────────────────────
  var tape = document.getElementById('ct');
  var SEG  = ['N','·','·','|','·','·','NE','·','·','|','·','·','E','·','·','|','·','·','SE','·','·','|','·','·','S','·','·','|','·','·','SW','·','·','|','·','·','W','·','·','|','·','·','NW','·','·','|','·','·'];
  var CARDS = {N:1,NE:1,E:1,SE:1,S:1,SW:1,W:1,NW:1};
  var cVel=0.8, cPos=0;
  var ONE_REP=SEG.length*22, CTOTAL=ONE_REP*5;

  if (tape) {
    var h='';
    for (var r=0;r<5;r++) SEG.forEach(function(s){h+='<span'+(CARDS[s]?' class="cc"':'')+'>'+s+'</span>';});
    tape.innerHTML=h;
  }

  function tickCompass() {
    // More erratic: bigger kicks, more frequent, less damping
    cVel += 0.22;
    if (Math.random() < 0.065) cVel += (Math.random()-0.32)*32;
    if (Math.random() < 0.02)  cVel -= (Math.random()*18); // occasional hard reversal
    cVel *= 0.915;
    cPos += cVel*0.05;
    cPos=((cPos%CTOTAL)+CTOTAL)%CTOTAL;
    if(tape) tape.style.transform='translateX('+(-(cPos%ONE_REP)-ONE_REP)+'px)';
    var heading=Math.round((cPos/ONE_REP*360)%360);
    var hmag=document.getElementById('hmag');
    if(hmag) hmag.textContent=String(heading).padStart(3,'0');
  }

  // ── SHOP WINDOW ───────────────────────────────────────────────────────────
  var shopWindow   = document.getElementById('shop-window');
  var shopBackdrop = document.getElementById('shop-backdrop');
  var urlPath      = document.querySelector('.top-bar .url-text');

  function showShopWindow() {
    if(shopWindow)   shopWindow.classList.add('open');
    if(shopBackdrop) shopBackdrop.classList.add('open');
    // Update top URL bar to show /shop
    if(urlPath) {
      urlPath.dataset.orig = urlPath.innerHTML;
      urlPath.innerHTML = '<a href="/">somar.us</a><span class="url-sep">/</span><span class="url-active">shop</span><span class="url-cursor">_</span>';
    }
  }
  function hideShopWindow() {
    if(shopWindow)   shopWindow.classList.remove('open');
    if(shopBackdrop) shopBackdrop.classList.remove('open');
    if(urlPath && urlPath.dataset.orig) urlPath.innerHTML = urlPath.dataset.orig;
  }

  if(shopBackdrop) shopBackdrop.addEventListener('click', hideShopWindow);
  var closeBtn=document.getElementById('shop-win-close');
  if(closeBtn) closeBtn.addEventListener('click', hideShopWindow);

  // Shop window nav dropdown hamburger
  var swNavBtn  = document.getElementById('sw-nav-btn');
  var swNavDrop = document.getElementById('sw-nav-drop');
  if(swNavBtn && swNavDrop){
    swNavBtn.addEventListener('click',function(e){e.stopPropagation();swNavDrop.classList.toggle('open');});
    document.addEventListener('click',function(){swNavDrop.classList.remove('open');});
  }

  // Cards inside shop window navigate with transition — block coming-soon
  [].slice.call(document.querySelectorAll('.swp-card')).forEach(function(c){
    c.addEventListener('click',function(e){
      e.preventDefault();
      if(c.classList.contains('is-coming-soon')){
        if(typeof window.showRestrictModal==='function') window.showRestrictModal(c.getAttribute('href'));
        return;
      }
      navigateTo(c.getAttribute('href'));
    });
  });
  var swAll=document.querySelector('.shop-win-all');
  if(swAll) swAll.addEventListener('click',function(e){e.preventDefault();navigateTo(this.getAttribute('href'));});

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') hideShopWindow();
  });

  // ── ARC NAV ──────────────────────────────────────────────────────────────
  var activeIdx=0;
  var items=[].slice.call(document.querySelectorAll('#nav-list li'));

  function getArcRadius() { return isHome ? 180 : (isPageTpl ? 90 : 0); }

  function updateArc() {
    var skip = isShopPage || isMobile();
    var NAV_R = getArcRadius();
    var ASTEP = isHome ? 0.42 : 0.3;

    items.forEach(function(el,i){
      if(skip || (!isHome && !isPageTpl)) {
        el.style.transform=''; el.style.opacity='';
        el.classList.toggle('on',i===activeIdx);
        return;
      }
      var d=i-activeIdx, theta=d*ASTEP;
      var x=NAV_R*(1-Math.cos(theta));
      var sc=Math.max(0.65,1-Math.abs(d)*0.1);
      var al=Math.max(0.22,1-Math.abs(d)*0.2);
      var ry=Math.min(Math.abs(d)*4,18);
      el.style.transform='translateX('+x+'px) scale('+sc+') perspective(500px) rotateY('+ry+'deg)';
      el.style.opacity=al;
      el.classList.toggle('on',i===activeIdx);
    });
    var hchan=document.getElementById('hchan');
    var dots=[].slice.call(document.querySelectorAll('.dot'));
    if(hchan) hchan.textContent=String(activeIdx+1).padStart(2,'0');
    dots.forEach(function(d,i){d.classList.toggle('on',i===activeIdx);});
  }

  // Detect current page in nav
  items.forEach(function(el,i){
    var href=el.dataset.href||'';
    if(href&&href!=='/'&&href!=='#'&&window.location.pathname.startsWith(href.split('?')[0]))
      activeIdx=i;
  });

  items.forEach(function(el,i){
    el.addEventListener('click',function(){
      activeIdx=i; updateArc();
      var href=el.dataset.href;
      if(!href||href==='#') return;
      setTimeout(function(){navigateTo(href);},120);
    });
    el.addEventListener('mouseenter',function(){
      if(!isShopPage && !isMobile()){ activeIdx=i; updateArc(); }
    });
  });

  // Clickable dots
  [].slice.call(document.querySelectorAll('.dot')).forEach(function(dot,i){
    dot.addEventListener('click',function(){
      activeIdx=i; updateArc();
      var item=items[i]; if(!item) return;
      var href=item.dataset.href;
      if(!href||href==='#') return;
      setTimeout(function(){navigateTo(href);},120);
    });
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='ArrowDown'){activeIdx=Math.min(activeIdx+1,items.length-1);updateArc();}
    if(e.key==='ArrowUp'){activeIdx=Math.max(activeIdx-1,0);updateArc();}
    if(e.key==='Enter'&&items[activeIdx]){
      var href=items[activeIdx].dataset.href;
      if(!href||href==='#') return;
      navigateTo(href);
    }
  });

  window.addEventListener('resize',function(){updateArc();});

  // ── MOUSE / CROSSHAIR ────────────────────────────────────────────────────
  var cur=document.getElementById('cur'),rh=document.getElementById('rh'),rv=document.getElementById('rv');
  if(!isMobile()){
    document.addEventListener('mousemove',function(e){
      VP.tx=(e.clientX/window.innerWidth-0.5)*2;
      VP.ty=(e.clientY/window.innerHeight-0.5)*2;
      if(cur){cur.style.left=e.clientX+'px';cur.style.top=e.clientY+'px';}
      if(rh) rh.style.top=e.clientY+'px';
      if(rv) rv.style.left=e.clientX+'px';
      var lat=(33.677-VP.ty*0.015).toFixed(5),lon=(-82.273+VP.tx*0.022).toFixed(5);
      var brg=String(Math.round(((Math.atan2(VP.tx,-VP.ty)*180/Math.PI)+360)%360)).padStart(3,'0');
      var $=function(id){return document.getElementById(id);};
      if($('hlat'))$('hlat').textContent=lat;
      if($('hlon'))$('hlon').textContent=lon;
      if($('hbrg'))$('hbrg').textContent=brg;
    });
  } else {
    // ── GYROSCOPE (sphere parallax + sigil tilt) ─────────────────────────
    var gyroBase = null;
    var swEl = document.querySelector('.sw');
    function applyOrientation(e) {
      if (!gyroBase) { gyroBase = { b: e.beta||0, g: e.gamma||0 }; return; }
      var db = (e.beta||0)  - gyroBase.b;
      var dg = (e.gamma||0) - gyroBase.g;
      VP.tx = Math.max(-1, Math.min(1, dg / 14));
      VP.ty = Math.max(-1, Math.min(1, db / 12));
      // Tilt the sigil/rings container with device orientation
      if (swEl) {
        swEl.style.transform = 'perspective(600px) rotateX(' + (db * 0.45) + 'deg) rotateY(' + (dg * 0.45) + 'deg)';
        swEl.style.transformStyle = 'preserve-3d';
      }
    }
    if (typeof DeviceOrientationEvent !== 'undefined') {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        // iOS 13+ — request on first touch
        document.addEventListener('touchstart', function reqGyro() {
          DeviceOrientationEvent.requestPermission().then(function(r) {
            if (r === 'granted') window.addEventListener('deviceorientation', applyOrientation, {passive:true});
          }).catch(function(){});
          document.removeEventListener('touchstart', reqGyro);
        }, {once:true, passive:true});
      } else {
        window.addEventListener('deviceorientation', applyOrientation, {passive:true});
      }
    }

    // ── TAP-AND-HOLD SNIPER SCOPE (magnifier lens) ───────────────────────
    var scopeBg = document.createElement('div');
    scopeBg.id = 'mob-scope-bg';
    document.body.appendChild(scopeBg);

    var scopeEl = document.createElement('div');
    scopeEl.id = 'mob-scope';
    var scopeZoomImg = document.createElement('img');
    scopeZoomImg.className = 'scope-zoom-img';
    scopeEl.appendChild(scopeZoomImg);
    ['scope-ring','scope-h','scope-v','scope-dot'].forEach(function(c) {
      var d = document.createElement('div'); d.className = c; scopeEl.appendChild(d);
    });
    document.body.appendChild(scopeEl);

    var LENS_R = 72, ZOOM = 2.8;
    var holdTimer = null, scopeActive = false;

    function hiresUrl(src) {
      if (!src) return src;
      if (src.indexOf('width=') !== -1) return src.replace(/width=\d+/, 'width=1400');
      return src.replace(/_(\d+)x(\.\w+)(\?|$)/, '_1400x$2$3');
    }

    function findImg(x, y) {
      var el = document.elementFromPoint(x, y);
      while (el && el !== document.body) {
        if (el.tagName === 'IMG' && el !== scopeZoomImg) return el;
        el = el.parentElement;
      }
      return null;
    }

    function moveLens(x, y) {
      scopeEl.style.left = x + 'px';
      scopeEl.style.top  = y + 'px';
      var img = findImg(x, y);
      if (img) {
        var hr = hiresUrl(img.src);
        if (scopeZoomImg.dataset.srcKey !== hr) {
          scopeZoomImg.src = hr;
          scopeZoomImg.dataset.srcKey = hr;
        }
        scopeZoomImg.style.display = 'block';
        var r = img.getBoundingClientRect();
        var rx = Math.max(0, Math.min(1, (x - r.left)  / r.width));
        var ry = Math.max(0, Math.min(1, (y - r.top)   / r.height));
        var iW = LENS_R * 2 * ZOOM;
        var iH = iW * (r.height / Math.max(1, r.width));
        scopeZoomImg.style.width  = iW + 'px';
        scopeZoomImg.style.height = iH + 'px';
        scopeZoomImg.style.left   = (-rx * iW + LENS_R) + 'px';
        scopeZoomImg.style.top    = (-ry * iH + LENS_R) + 'px';
      } else {
        scopeZoomImg.style.display = 'none';
      }
    }

    // Non-passive drag listener — added only while scope is active
    var onScopeDrag = function(e) {
      e.preventDefault();
      var t = e.touches[0];
      moveLens(t.clientX, t.clientY);
    };

    document.addEventListener('touchstart', function(e) {
      var t = e.touches[0], sx = t.clientX, sy = t.clientY;
      holdTimer = setTimeout(function() {
        scopeActive = true;
        document.body.classList.add('scope-on');
        moveLens(sx, sy);
        document.addEventListener('touchmove', onScopeDrag, {passive: false});
        if (navigator.vibrate) navigator.vibrate(35);
      }, 480);
    }, {passive: true});

    // Cancel hold on early move
    document.addEventListener('touchmove', function() {
      if (!scopeActive) clearTimeout(holdTimer);
    }, {passive: true});

    ['touchend','touchcancel'].forEach(function(ev) {
      document.addEventListener(ev, function() {
        clearTimeout(holdTimer);
        if (scopeActive) {
          scopeActive = false;
          document.body.classList.remove('scope-on');
          document.removeEventListener('touchmove', onScopeDrag);
        }
      }, {passive: true});
    });
  }

  // ── CLOCK — 24h + full date ───────────────────────────────────────────────
  var MONTHS=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  function tick(){
    var d=new Date(),pad=function(n){return String(n).padStart(2,'0');};
    var t=document.getElementById('htime'),dt=document.getElementById('hdate');
    if(t) t.textContent=[d.getHours(),d.getMinutes(),d.getSeconds()].map(pad).join(':');
    if(dt) dt.textContent=MONTHS[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear();
  }
  setInterval(tick,1000); tick();

  // ── DARK MODE ────────────────────────────────────────────────────────────────
  // Session-only: night mode survives page navigation but every NEW visit starts in
  // day mode. (Old localStorage persistence made the site appear to "turn itself dark"
  // on entry — purge the legacy key so previously-affected browsers reset.)
  try { localStorage.removeItem('somar-dark'); } catch (e) {}
  var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
  if (inDesignMode) {
    document.body.classList.remove('dark-mode');
    document.documentElement.classList.remove('dark-mode');
  } else if (sessionStorage.getItem('somar-dark') === '1') {
    document.body.classList.add('dark-mode');
    document.documentElement.classList.add('dark-mode');
  }
  // Attach to all .dm-toggle buttons (top-bar + pw-hdr in collection/product windows)
  [].forEach.call(document.querySelectorAll('.dm-toggle'), function(btn) {
    btn.addEventListener('click', function() {
      var dark = document.body.classList.toggle('dark-mode');
      document.documentElement.classList.toggle('dark-mode', dark);
      try { sessionStorage.setItem('somar-dark', dark ? '1' : '0'); } catch (e) {}
    });
  });

  // ── MOBILE GYROSCOPE — sphere rotates 360° with the device ─────────────────
  var GYRO = { on:false, az:0, el:0, sAz:0, sEl:0, seeded:false };
  function gyroHandler(ev) {
    if (ev.alpha == null && ev.beta == null) return;
    // alpha: 0-360 compass yaw (increases counter-clockwise) → invert so turning right pans right
    var az = 360 - (ev.alpha || 0);
    // beta shrinks as the phone tilts up toward the sky — so up is 60 - beta
    // (~60° is a natural holding angle → level view)
    var el = Math.max(-80, Math.min(80, 60 - (ev.beta || 0)));
    GYRO.az = az; GYRO.el = el;
    if (!GYRO.seeded) { GYRO.sAz = az; GYRO.sEl = el; GYRO.seeded = true; }
    GYRO.on = true;
  }
  function enableGyro() {
    window.addEventListener('deviceorientation', gyroHandler, true);
  }
  if (isMobile() && 'DeviceOrientationEvent' in window) {
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      // iOS: permission prompt requires a user gesture — hook the first tap
      var askGyro = function() {
        DeviceOrientationEvent.requestPermission()
          .then(function(s) { if (s === 'granted') enableGyro(); })
          .catch(function() {});
        document.removeEventListener('touchend', askGyro);
        document.removeEventListener('click', askGyro);
      };
      document.addEventListener('touchend', askGyro);
      document.addEventListener('click', askGyro);
    } else {
      enableGyro(); // Android and older iOS fire without permission
    }
  }

  // ── MAIN LOOP ─────────────────────────────────────────────────────────────
  updateArc();
  function loop(){
    if (GYRO.on) {
      // Smooth toward gyro heading, wrapping azimuth across 0/360
      var dAz = ((GYRO.az - GYRO.sAz + 540) % 360) - 180;
      GYRO.sAz = (GYRO.sAz + dAz * 0.12 + 360) % 360;
      GYRO.sEl += (GYRO.el - GYRO.sEl) * 0.12;
      drawGrid(GYRO.sEl, GYRO.sAz);
    } else {
      var nx=Math.sign(VP.tx)*Math.pow(Math.abs(VP.tx),1.4);
      var ny=Math.sign(VP.ty)*Math.pow(Math.abs(VP.ty),1.4);
      VP.vAz+=(nx*40-VP.vAz)*LERP;
      VP.vEl+=(-ny*25-VP.vEl)*LERP;
      drawGrid(VP.vEl,VP.vAz);
    }
    tickCompass();
    requestAnimationFrame(loop);
  }
  loop();

})();
